import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import meta from '../../settings/meta';
import sounds from '../../settings/sounds';
import { SoundsProvider } from '../SoundsProvider';

const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Person',
      name: meta.author,
      jobTitle: 'Developer',
      description: meta.description,
      email: meta.email,
      image: meta.seoImage,
      url: meta.url,
      sameAs: meta.sameAs
    },
    {
      '@type': 'WebSite',
      name: meta.title,
      url: meta.url,
      description: meta.description
    }
  ]
};

const Component = ({ children }) => (
  <>
    <Helmet>
      <html lang='en' />

      <meta name='viewport' content='width=device-width, initial-scale=1' />
      <meta httpEquiv='X-UA-Compatible' content='IE=edge,chrome=1' />

      <meta name='robots' content='index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' />
      <meta name='googlebot' content='index, follow' />
      <meta name='author' content={meta.author} />
      <meta name='color-scheme' content='dark' />
      <title>{meta.title}</title>
      <meta name='description' content={meta.description} />
      <meta name='keywords' content={meta.keywords} />

      <meta property='og:title' content={meta.title} />
      <meta property='og:site_name' content={meta.title} />
      <meta property='og:description' content={meta.description} />
      <meta property='og:type' content='website' />
      <meta property='og:url' content={meta.url} />
      <meta property='og:image' content={meta.seoImage} />
      <meta property='og:image:alt' content={meta.seoImageAlt} />
      <meta property='og:locale' content='en_US' />

      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={meta.title} />
      <meta name='twitter:description' content={meta.description} />
      {meta.twitter && <meta name='twitter:site' content={meta.twitter} />}
      {meta.twitter && <meta name='twitter:creator' content={meta.twitter} />}
      <meta name='twitter:image' content={meta.seoImage} />

      <meta name='mobile-web-app-capable' content='yes' />
      <meta name='theme-color' content={meta.color} />
      <meta name='apple-mobile-web-app-capable' content='yes' />
      <meta name='apple-mobile-web-app-title' content={meta.title} />
      <meta name='apple-mobile-web-app-status-bar-style' content={meta.color} />
      <meta name='msapplication-TileColor' content={meta.color} />

      <link rel='preconnect' href='https://fonts.googleapis.com' />
      <link rel='preconnect' href='https://fonts.gstatic.com' crossOrigin='anonymous' />
      <link
        rel='stylesheet'
        href='https://fonts.googleapis.com/css?family=Orbitron:400,500,700|Electrolize&display=swap'
      />
      <link rel='preload' href='/Camiro.ttf' as='font' type='font/ttf' crossOrigin='anonymous' />
      <link rel='canonical' href={meta.url} />
      <link rel='icon' type='image/webp' href='/images/me.webp' />
      <style type='text/css'>
        {`
          @font-face {
            font-family: 'Camiro';
            src: url('/Camiro.ttf') format('truetype');
            font-display: swap;
          }
        `}
      </style>
      <script type='application/ld+json'>
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
    <SoundsProvider sounds={sounds}>
      {children}
    </SoundsProvider>
  </>
);

Component.displayName = 'Layout';

Component.propTypes = {
  children: PropTypes.node.isRequired
};

export { Component };
